import { getStorage } from '@/utils'
export default {
  computed: {
    codeMapping() {
      return process.env.VUE_APP_RESULT_MAPPING.code || 'code'
    },
    dataMapping() {
      return process.env.VUE_APP_RESULT_MAPPING.data || 'value'
    },
    isXZH() {
      return process.env.VUE_APP_PROJECT_NAME === '新综合'
    }
  },
  methods: {
    jumpIpi(expression, val, publicOrder) {
      const code = getStorage('user', 0).code
      let perUrl = ''
      const type = process.env.VUE_APP_TYPE
      switch (type) {
        case 'serve':
          perUrl = 'http://192.168.2.31:8083/fvue'
          break
        case 'pre':
          perUrl = `http://${code}.ipsunlight.com:9080/fvue`
          break
        case 'pro':
          if (code === 'sdu') {
            perUrl = 'https://zscqlib.sdu.edu.cn/fvue'
          } else if (code === 'upc') {
            perUrl = 'https://zscq.upc.edu.cn/fvue'
          } else {
            perUrl = `https://${code}.ipsunlight.com/fvue`
          }
          break
      }
      let url = `${perUrl}/patyeeSearch?q=${expression}&pageType=school`
      if (val && val === 'isMerge') {
        url = url + '&isMerge=true'
      }
      if (publicOrder && publicOrder === 'publicOrder') {
        url = url + '&publicOrder=true'
      }
      window.open(url, '_blank')
    }
  }
}
